import { useQuery } from '@tanstack/react-query';

import type { Channel, StreamChat } from 'stream-chat';

import { CHAT_KEYS } from '@/constants/queryKeys';
import { toUnreadPeers } from '@/utils/chat';

const PAGE_SIZE = 30;
const MAX_PAGES = 10;

const loadChannels = async (client: StreamChat, staffID: string, page: number = 0): Promise<Channel[]> => {
  const found = await client.queryChannels(
    { type: 'messaging', members: { $in: [staffID] } },
    [{ last_message_at: -1 }],
    {
      limit: PAGE_SIZE,
      offset: page * PAGE_SIZE,
      state: true,
      watch: false,
    },
  );

  if (found.length < PAGE_SIZE || page + 1 >= MAX_PAGES) {
    return found;
  }

  return [...found, ...await loadChannels(client, staffID, page + 1)];
};

const useUnreadPeers = (client: StreamChat | null, isEnabled: boolean = true) => {
  const staffID = client?.userID ?? '';

  return useQuery({
    queryKey: CHAT_KEYS.unreadPeers(staffID),
    queryFn: async () => {
      if (!client) {
        return [];
      }

      return toUnreadPeers(await loadChannels(client, staffID), staffID);
    },
    enabled: isEnabled && staffID.length > 0,
  });
};

export {
  useUnreadPeers,
};
